import {
    useSiteSettings,
    DEFAULT_INDEX_LAYOUTS,
    type IndexLayoutConfig,
    type IndexPageKey,
} from "@/context/SiteSettingsContext";

/**
 * The admin-configured layout for one index page.
 *
 * Falls back to that page's historical look while settings load, so a
 * cold visit renders the familiar layout rather than flickering through a
 * different style. The settings context serves its localStorage cache
 * before the API answers, so a returning visitor sees the configured
 * value immediately — which is what makes a change in the Visibility tab
 * show up on the page itself.
 */
export function useIndexLayout(page: IndexPageKey): IndexLayoutConfig {
    const { settings } = useSiteSettings();
    return settings.indexLayouts?.[page] ?? DEFAULT_INDEX_LAYOUTS[page];
}
